import React, { useEffect, useState } from 'react';

/**
 * CommonLeisureDenetim: Common Leisure'ın dijital altyapısının dışarıdan
 * denetimi. Route: /r/common-leisure-denetim (sidebar YOK, tam ekran slayt).
 *
 * 14 slayt, 16:9. Tasarım dili Gürgençler lansman fikirleri sunumundan geliyor,
 * CSS'i onunla ortak; o sunumlar canlıda duruyor ve bozulmamalı.
 * Yeniden üretmek için: node src/pages/common-leisure-denetim/build.js
 *
 * 🔑 "PDF indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P slaytları
 * tek sayfaya kırpar; düğmeyi dışarı taşıma.
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 *
 * HTML modülü ~115KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function CommonLeisureDenetim() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./commonLeisureDenetimHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Common Leisure · Dijital Altyapı Röntgeni"
      srcDoc={html}
      style={fill}
    />
  );
}
